import "./ClientDashboardViewComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {ReplaySubject} from "rxjs";
import {ClientDashboardModel} from "../models/ClientDashboardModel";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {Branding} from "../../../types/Branding";
import {BrokerageOfferService} from "../../../services/iv/brokerage-offer/BrokerageOfferService";
import {ClientDashboardViewStore} from "../../common/store/ClientDashboardViewStore";
import {ViewType} from "../../common/types/ViewType";

import template from "./ClientDashboardViewComponent.html";

export const ClientDashboardView = "tfClientDashboardView";

export function clientDashboardView(): IComponentOptions {
    return {
        template,
        bindings: {
            model: "<"
        },
        controllerAs: "ctrl",
        controller: ClientDashboardViewComponentController
    };
}

export class ClientDashboardViewComponentController implements IOnInit, IOnDestroy {

    public model: ClientDashboardModel;

    public viewType: ViewType = "desktop";

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly $scope: IScope,
                       private readonly clientDashboardViewStore: ClientDashboardViewStore,
                       private readonly currentUserService: CurrentUserService,
                       private readonly ivBrokerageOfferService: BrokerageOfferService) {
    }

    public $onInit(): void {
        this.watchSizeChange();

        if (this.currentUserService.isBranding(Branding.IV)) {
            this.ivBrokerageOfferService.maybeShowIvBrokerageOffer();
        }
    }

    private watchSizeChange() {
        this.clientDashboardViewStore
            .viewType
            .takeUntil(this.destroyed$)
            .subscribe((view) => {
                this.$scope.$applyAsync(() => this.viewType = view);
            });
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
